<template>
  <div>
    <v-icon
    style="font-size: 30px"
    :color="getTypeColorAndIcon().classColor"
    >
    {{ getTypeColorAndIcon().icon }}
    </v-icon>
  </div>
</template>

<script>
  export default {
    name: "DocumentTypeIcon",
    props: {
      type: String,
      componentWidth: {
        type: String,
        default: "200px"
      },
      componentHeight: {
        type: String,
        default: "200px"
      }
    },
    methods: {
      getTypeColorAndIcon() {
        let color = "";
        let icon = "mdi-";
        let classColor = "";
        switch (this.type) {
          case "pdf": {
            color = "#EF9A9A;";
            icon += "file-pdf-box";
            classColor = "red lighten-1";
            break;
          }
          case "word": {
            color = "#64B5F6;";
            icon += "file-word";
            classColor = "blue lighten-1";
            break;
          }
          case "sheet": {
            color = "#66BB6A;";
            icon += "file-excel";
            classColor = "green lighten-1";
            break;
          }
          case "pptx": {
            color = "#FFB74D;";
            icon += "file-powerpoint";
            classColor = "orange lighten-1";
            break;
          }
          case "image": {
            color = "#EF9A9A";
            icon += 'image';
            classColor = "blue lighten-1";
            break;
          }
          default: {
            color = "#EEEEEE";
            icon += "file-document";
            classColor = "grey lighten-1";
            break;
          }
        }
        return { color, icon, classColor };
      },
    },
    computed: {
      computedCardBorder() {
        let style = "border: 3px solid " + this.getTypeColorAndIcon().color;
        return style;
      },
    },
  };
</script>

<style></style>
